import React, { useEffect, useState } from "react";
import { adblockEnabled, arrayBufferToBase64, isValidEmail } from "../util/helpers";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const MailForwarder = (Component) => (props) => {
  const fileInput = React.createRef();
  const state = useSelector((state) => state);
  const [attachment, setAttachment] = useState();
  const [attachmentName, setAttachmentName] = useState("");
  const [attachmentType, setAttachmentType] = useState("");
  const [desc, setDesc] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [fileReader, setFileReader] = useState();
  const [isPosting, setIsPosting] = useState(false);
  const [notARobot, setNotARobot] = useState(false);
  const [success, setSuccess] = useState("");

  useEffect(() => {
    setFileReader(new window.FileReader());
  }, []);

  const onCaptcha = () => {
    const { captcha, ...otherErrors } = errors;
    setErrors(otherErrors);
    setNotARobot(true);
  };

  const onChangeDesc = (e) => {
    const { desc, ...otherErrors } = errors;
    setErrors(otherErrors);
    setDesc(e.target.value);
  };

  const onChangeEmail = (e) => {
    const { email, ...otherErrors } = errors;
    setErrors(otherErrors);
    setEmail(e.target.value);
  };

  const onFileChosen = (e) => {
    const { file, ...otherErrors } = errors;

    if (!e.target.files) {
      setAttachment(null);
      return setErrors(otherErrors);
    } else if (e.target.files[0].size > 50 * 1024 * 1024) {
      return setErrors({ ...otherErrors, file: "Screenshots must be smaller than 5 MB" });
    }

    fileReader.onloadend = () => setAttachment(arrayBufferToBase64(fileReader.result));
    fileReader.readAsArrayBuffer(e.target.files[0]);

    setAttachmentName(e.target.files[0].name);
    setAttachmentType(e.target.files[0].type);
  };

  const onSubmit = async (to) => {
    const { submit, ...oldErrors } = errors;

    let newErrors = {};
    if (!isValidEmail(email)) {
      newErrors["email"] = "Plese enter a valid email address.";
    }
    if (desc === "") {
      newErrors["desc"] = "Please enter description.";
    }
    if (!notARobot) {
      newErrors["captcha"] = "Captcha failed.";
    }

    if (Object.keys(newErrors).length !== 0) {
      return setErrors({ ...oldErrors, ...newErrors });
    }

    setErrors({});
    setIsPosting(true);
    setSuccess("");

    let status;
    try {
      const res = await fetch(
        "https://jzrbmh0wac.execute-api.us-east-1.amazonaws.com/stage-0/contact-us",
        {
          body: JSON.stringify({
            adblockEnabled: adblockEnabled(),
            attachment,
            attachmentName,
            attachmentType,
            desc,
            email,
            history: state.history,
            state,
            to: "edhrec@edhrec.com",
          }),
          headers: { "Content-Type": "application/json" },
          method: "POST",
        }
      );
      status = res.status;
      const json = await res.json();
      // eslint-disable-next-line no-prototype-builtins
      if (json.hasOwnProperty("errorMessage")) {
        setErrors({ submit: `Error: ${json.errorMessage}` });
        setIsPosting(false);
      }
    } catch (error) {
      if (status === 200) {
        setIsPosting(false);
        setSuccess("Message received, thanks!");
      } else {
        setErrors({ submit: `Error: ${error.message}` });
        setIsPosting(false);
      }
    }
  };

  return (
    <Component
      {...props}
      desc={desc}
      email={email}
      errors={errors}
      fileInput={fileInput}
      isPosting={isPosting}
      onCaptcha={onCaptcha}
      onChangeDesc={onChangeDesc}
      onChangeEmail={onChangeEmail}
      onFileChosen={onFileChosen}
      onSubmit={onSubmit}
      success={success}
    />
  );
};

MailForwarder.propTypes = {
  children: PropTypes.element.isRequired,
};

export default MailForwarder;
